import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';
import LogoCarNew from '@/assets/svg/detailed-car/pdf/logo-footer-pdf.svg';

import Header from './components/Header';
import Complectation from './components/Complectation';
import PaymentInfo from './components/PaymentInfo';
import Footer from './components/Footer';

function DetailedCarNewPdfTemplate() {
  return (
    <Component id="printPdfTemplateContentNewCar">
      <ComponentWrapper>
        <Header />
        <Container>
          <Complectation />
          <ContainerFooter>
            <PaymentInfo />
            <Footer />
            <Logo>
              <LogoCarNew />
            </Logo>
          </ContainerFooter>
        </Container>
      </ComponentWrapper>
    </Component>
  );
}

export default DetailedCarNewPdfTemplate;

const Component = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  visibility: hidden;

  @media (max-width: 600px) {
    @media not print {
      display: none;
    }
  }

  @media print {
    position: static;
    visibility: visible;
  }
`;

const ComponentWrapper = styled.div`
  margin: 0 auto;
  width: 100vw;
`;

const Container = styled.div`
  background-color: ${colors.white};
  padding: 19px 41px 0;
`;

const ContainerFooter = styled.div`
  position: relative;
`;

const Logo = styled.div`
  position: absolute;
  right: -41px;
  bottom: 0px;
`;
